import React from "react";
import "./Repertoire.css";

function Repertoire() {
  return (
    <div className="repertoire-container">
      <h1>Repertoire List</h1>
      <h2>SOOHYUN JO, Soprano</h2>

      <div className="repertoire-section">
        <h3>Arias</h3>
        
        {/* Italian */}
        <div className="language-section">
          <h4>Italian</h4>
          <hr className="section-divider" />
          
          <div className="composer-works">
            <h5>G. F. Handel</h5>
            <ul>
              <li>V'adoro, pupille ⟨Giulio Cesare⟩</li>
              <li>Furie Terribili ⟨Rinaldo⟩</li>
            </ul>
          </div>
          
          <div className="composer-works">
            <h5>W. A. Mozart</h5>
            <ul>
              <li>In uomini, in soldati ⟨Cosi Fan Tutte⟩</li>
              <li>D'oreste d'ajace ⟨Idomeneo⟩</li>
            </ul>
          </div>
          
          <div className="composer-works">
            <h5>G. Donizetti</h5>
            <ul>
              <li>Quel guardo il cavaliere ⟨Don Pasquale⟩</li>
            </ul>
          </div>

          <div className="composer-works">
            <h5>G. Verdi</h5>
            <ul>
              <li>Saper vorrete di che si veste ⟨Un Ballo in Maschera⟩</li>
              <li>Volta la terrea fronte alle stelle ⟨Un Ballo in Maschera⟩</li>
            </ul>
          </div>

          <div className="composer-works">
            <h5>G. Puccini</h5>
            <ul>
              <li>Quando m'en vo ⟨La Bohème⟩</li>
              <li>Donde lieta ⟨La Bohème⟩</li>
              <li>Chi il bel sogno di Doretta ⟨La Rondine⟩</li>
              <li>O mio babbino caro ⟨Gianni Schicchi⟩</li>
            </ul>
          </div>
        </div>

        {/* German */}
        <div className="language-section">
          <h4>German</h4>
          <hr className="section-divider" />
          
          <div className="composer-works">
            <h5>W. A. Mozart</h5>
            <ul>
              <li>Ach ich fühl's ⟨Die Zauberflöte⟩</li>
            </ul>
          </div>
        </div>

        {/* French */}
        <div className="language-section">
          <h4>French</h4>
          <hr className="section-divider" />
          
          <div className="composer-works">
            <h5>C. F. Gounod</h5>
            <ul>
              <li>Air des Bijoux ⟨Faust⟩</li>
              <li>Je Veux vivre ⟨Roméo et Juliette⟩</li>
            </ul>
          </div>
          
          <div className="composer-works">
            <h5>G. Donizetti</h5>
            <ul>
              <li>Chacun le sait ⟨La Fille du Régiment⟩</li>
            </ul>
          </div>
        </div>

        {/* English */}
        <div className="language-section">
          <h4>English</h4>
          <hr className="section-divider" />
          
          <div className="composer-works">
            <h5>A. Beach</h5>
            <ul>
              <li>The Year's at the Spring</li>
            </ul>

            <h5>L. Ronald</h5>
            <ul>
              <li>Prelude</li>
              <li>Love, I Have Won You</li>
            </ul>

            <h5>J. Heggie</h5>
            <ul>
              <li>Paper Wings</li>
            </ul>

            <h5>A. Previn</h5>
            <ul>
              <li>I Want Magic ⟨A Streetcar Named Desire⟩</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Repertoire;